<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
						<a href="#">{{ $t('HomeMenu') }}</a>
					</router-link>
					<router-link :to="{ name: 'Character' }" tag="li" class="breadcrumb-item">
						<a href="#">{{ $t('CharacterMenu') }}</a>
					</router-link>
				</ol>
			</nav>
			<div class="row">
				<div class="col-lg-12 col-md-12 col-12">

					<div class="item-box">
						<div class="d-flex flex-wrap">
							<button title="依照角色原始的稀有度作為排序" type="button" @click="changeFilter(''); changeShowType('')"
								class="pcbtn mr-3 mb-3" :class="filter == '' ? 'active' : ''">
								{{ $t('Rarity') }} </button>
							<button title="依照角色的年齡作為排序" type="button" @click="changeFilter('age'); changeShowType('1')"
								class="pcbtn mr-3 mb-3" :class="filter == 'age' ? 'active' : ''">
								{{ $t('Age') }} <span v-if="filter == 'age'" :class="arrange == 'desc' ? 'down' : 'up'"
									class="icon-custom inline"></span>
							</button>
							<button title="依照角色的身高作為排序" type="button"
								@click="changeFilter('height'); changeShowType('1')" class="pcbtn mr-3 mb-3"
								:class="filter == 'height' ? 'active' : ''">
								{{ $t('Height') }} <span v-if="filter == 'height'"
									:class="arrange == 'desc' ? 'down' : 'up'" class="icon-custom inline"></span>
							</button>
							<button title="依照角色的體重作為排序" type="button"
								@click="changeFilter('weight'); changeShowType('1')" class="pcbtn mr-3 mb-3"
								:class="filter == 'weight' ? 'active' : ''">
								{{ $t('Weight') }} <span v-if="filter == 'weight'"
									:class="arrange == 'desc' ? 'down' : 'up'" class="icon-custom inline"></span>
							</button>
							<button title="依照角色的站位順序作為排序" type="button"
								@click="changeFilter('search_area_width'); changeShowType('1')" class="pcbtn mr-3 mb-3"
								:class="filter == 'search_area_width' ? 'active' : ''">
								{{ $t('Distance') }} <span v-if="filter == 'search_area_width'"
									:class="arrange == 'desc' ? 'down' : 'up'" class="icon-custom inline"></span>
							</button>
							<button title="列出六星的角色" type="button" @click="changeFilter('star6'); changeShowType('1')"
								class="pcbtn mr-3 mb-3" :class="filter == 'star6' ? 'active' : ''">
								{{ $t('SixStar') }} <span v-if="filter == 'star6'"
									:class="arrange == 'desc' ? 'down' : 'up'" class="icon-custom inline"></span>
							</button>
							<button title="依照角色的公會作為排序" type="button"
								@click="changeFilter('guild'); changeShowType('2')" class="pcbtn mr-3 mb-3"
								:class="filter == 'guild' ? 'active' : ''">
								{{ $t('Guild') }}
							</button>
							<button title="列出卡池的分類" type="button" @click="changeFilter('gacha'); changeShowType('3')"
								class="pcbtn mr-3 mb-3" :class="filter == 'gacha' ? 'active' : ''">
								{{ $t('GachaType') }}
							</button>
							<button title="只顯示前衛的角色" type="button" @click="changeFilter('p1'); changeShowType('1')"
								class="pcbtn mr-3 mb-3" :class="filter == 'p1' ? 'active' : ''">
								{{ $t('FrontPosition') }} <span v-if="filter == 'p1'"
									:class="arrange == 'desc' ? 'down' : 'up'" class="icon-custom inline"></span>
							</button>
							<button title="只顯示中衛的角色" type="button" @click="changeFilter('p2'); changeShowType('1')"
								class="pcbtn mr-3 mb-3" :class="filter == 'p2' ? 'active' : ''">
								{{ $t('MiddlePosition') }} <span v-if="filter == 'p2'"
									:class="arrange == 'desc' ? 'down' : 'up'" class="icon-custom inline"></span>
							</button>
							<button title="只顯示後衛的角色" type="button" @click="changeFilter('p3'); changeShowType('1')"
								class="pcbtn mr-3 mb-3" :class="filter == 'p3' ? 'active' : ''">
								{{ $t('BackPosition') }} <span v-if="filter == 'p3'"
									:class="arrange == 'desc' ? 'down' : 'up'" class="icon-custom inline"></span>
							</button>
							<template v-for="n in 5">
								<button type="button" @click="changeFilter('t' + n); changeShowType('1')"
									class="pcbtn mr-3 mb-3" :class="filter == 't' + n ? 'active' : ''">
									<div class="d-flex">
										<span :class="'icon icon-ele t' + n"></span>
										<span v-if="filter == 't' + n" :class="arrange == 'desc' ? 'down' : 'up'"
											class="ml-1 icon-custom inline"></span>
									</div>
								</button>
							</template>
						</div>
						<div class="d-flex flex-wrap mb-3">
							<input type="text" class="form-control search-btn" :placeholder="$t('search_by_unitname')"
								aria-label="Search for..." v-on:input="debounceInput" />
						</div>
						<template v-if="showType == '1'">
							<div class="pb-3 lg-pt-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
								<div class="m-2 c-box anm-float" v-for="item in allUnit">
									<router-link :to="{ name: 'CharacterDetail', params: { id: item.kana } }">
										<div class="card-deck">
											<div class="card">
												<img class="img-fluid"
													v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 60) + '.png'"
													alt="" v-if="filter == 'star6'">
												<img class="img-fluid"
													v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'"
													alt="" v-else>
												<div class="card-footer text-center">
													<small class="text-muted">{{ getUnitName(item) }}</small>
													<br>
													<small class="text-muted">{{ item.profile[filter] }}</small>
												</div>
											</div>
											<div class="c-box-element">
												<span :class="'icon icon-ele t' + item.talent_id"></span>
											</div>
										</div>
									</router-link>
								</div>
							</div>
						</template>
						<template v-else-if="showType == '2'">
							<div class="pb-3 lg-pt-3 d-flex flex-wrap">
								<template v-for="(guildMember, index) in guildUnit">
									<h3 class="item-title w-100">
										{{ index }}
									</h3>
									<div class="m-2 c-box anm-float" v-for="item in guildMember">
										<router-link :to="{ name: 'CharacterDetail', params: { id: item.kana } }">
											<div class="card-deck">
												<div class="card">
													<img class="img-fluid"
														v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'"
														alt="">
													<div class="card-footer text-center">
														<small class="text-muted">{{ getUnitName(item) }}</small>
													</div>
												</div>
											</div>
										</router-link>
									</div>
								</template>
							</div>
						</template>
						<template v-else-if="showType == '3'">
							<div class="pb-3 lg-pt-3 d-flex flex-wrap">
								<template v-for="(gachaItem, index) in gachaPoolList" v-if="gachaItem.length > 0">
									<h3 class="item-title w-100">
										{{ gachaPoolTitle(index) }}
									</h3>
									<div class="m-2 c-box anm-float" v-for="item in gachaItem">
										<router-link :to="{ name: 'CharacterDetail', params: { id: item.kana } }">
											<div class="card-deck">
												<div class="card">
													<img class="img-fluid"
														v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'"
														alt="">
													<div class="card-footer text-center">
														<small class="text-muted">{{ getUnitName(item) }}</small>
													</div>
												</div>
											</div>
										</router-link>
									</div>
								</template>
							</div>
						</template>
						<template v-else>
							<div class="pb-3 lg-pt-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
								<h3 class="item-title w-100">
									3 {{ $t('star') }}
								</h3>
								<div class="m-2 c-box anm-float" v-for="item in star3">
									<router-link :to="{ name: 'CharacterDetail', params: { id: item.kana } }">
										<div class="card-deck">
											<div class="card">
												<img class="img-fluid"
													v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'"
													alt="">
												<div class="card-footer text-center">
													<small class="text-muted">{{ getUnitName(item) }}</small>
												</div>
											</div>
											<div class="c-box-element">
												<span :class="'icon icon-ele t' + item.talent_id"></span>
											</div>
										</div>
									</router-link>
								</div>
							</div>
							<div class="pb-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
								<h3 class="item-title w-100">
									2 {{ $t('star') }}
								</h3>
								<div class="m-2 c-box anm-float" v-for="item in star2">
									<router-link :to="{ name: 'CharacterDetail', params: { id: item.kana } }">
										<div class="card-deck">
											<div class="card">
												<img class="img-fluid"
													v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 10) + '.png'"
													alt="">
												<div class="card-footer text-center">
													<small class="text-muted">{{ getUnitName(item) }}</small>
												</div>
											</div>
											<div class="c-box-element">
												<span :class="'icon icon-ele t' + item.talent_id"></span>
											</div>
										</div>
									</router-link>
								</div>
							</div>
							<div class="pb-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
								<h3 class="item-title w-100">
									1 {{ $t('star') }}
								</h3>
								<div class="m-2 c-box anm-float" v-for="item in star1">
									<router-link :to="{ name: 'CharacterDetail', params: { id: item.kana } }">
										<div class="card-deck">
											<div class="card">
												<img class="img-fluid"
													v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 10) + '.png'"
													alt="">
												<div class="card-footer text-center">
													<small class="text-muted">{{ getUnitName(item) }}</small>
												</div>
												<div class="c-box-element">
													<span :class="'icon icon-ele t' + item.talent_id"></span>
												</div>
											</div>
										</div>
									</router-link>
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import unit_profile from "../assets/edata/unit_profile.txt";
import GachaPool from "../assets/edata/gacha_pool.json";
import unit_talent from "../assets/edata/unit_talent.txt";
export default {
	name: 'Character',
	data() {
		return {
			star3: {},
			star2: {},
			star1: {},
			filter: "",
			filterName: "",
			arrange: "desc",
			showType: "",
			unitProfile: {},
			gachaPool: GachaPool,
			elementIconList: ['t1', 't2', 't3', 't4', 't5']
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '人物列表',
	},
	computed: {
		locale() {
			return this.$i18n.locale
		},
		allUnit: function () {
			var self = this;
			var unit_data = self.$store.getters.getUnitData;
			var actualUnits = self.$store.getters.getCharaIdentity;
			var filter = this.filter;
			let filterName = this.filterName;
			var list = new Array();
			_.forEach(unit_data, function (value) {
				_.forEach(actualUnits, function (o) {
					try {
						if (o.unit_id == _.toInteger(value.unit_id) && value.cutin_1 != "0") {
							var profile = _.find(self.unitProfile, ["unit_id", value.unit_id]);
							o["rarity"] = value.rarity;
							o["kana"] = value.unit_name;
							o["guild_id"] = value.guild_id;
							o["profile"] = profile;
							o.profile.search_area_width = value.search_area_width;
							list.push(o);
						}

					} catch (e) {
						console.log(o)
						console.log(e);
					}

				});
			});

			if (filterName != '') {
				list = _.filter(list, function (o) {
					return _.includes(o.en_unit_name.toLowerCase(), filterName.toLowerCase())
						|| _.includes(o.jp_unit_name, filterName)
						|| _.includes(o.cn_unit_name, filterName)
						|| _.includes(o.kana.toLowerCase(), filterName.toLowerCase());
				});
			}

			if (filter == 'star6') {
				var star6List = _.remove(_.map(self.$store.getters.getUnitRarity, function (o) {
					if (o.rarity == 6) {
						return o.unit_id
					}
				}), _.identity)
				list = _.filter(list, function (o) {
					return _.includes(star6List, o.unit_id);
				});
				return list = _.orderBy(list, function (e) { return Number(e.profile["search_area_width"]) }, [self.arrange]);
			}
			if (filter == "p1" || filter == "p2" || filter == "p3") {
				switch (filter) {
					case "p1":
						list = _.filter(list, function (x) { return Number(x.profile.search_area_width) < 300 })
						return list = _.orderBy(list, function (e) { return Number(e.profile["search_area_width"]) }, [self.arrange]);
						break;
					case "p2":
						list = _.filter(list, function (x) { return Number(x.profile.search_area_width) > 300 && Number(x.profile.search_area_width) < 600 })
						return list = _.orderBy(list, function (e) { return Number(e.profile["search_area_width"]) }, [self.arrange]);
						break;
					case "p3":
						list = _.filter(list, function (x) { return Number(x.profile.search_area_width) > 600 && Number(x.profile.search_area_width) < 900 })
						return list = _.orderBy(list, function (e) { return Number(e.profile["search_area_width"]) }, [self.arrange]);
						break;
					default:
						break;
				}

			}

			if (self.elementIconList.includes(filter)) {
				list = _.filter(list, function (x) { return x.talent_id == filter.split('')[1] })
				return list = _.orderBy(list, function (e) { return Number(e.profile["search_area_width"]) }, [self.arrange]);
			}

			var filterType = "";

			list = _.orderBy(list, function (e) { return Number(e.profile[filter]) }, [self.arrange]);
			return list;
		},
		guildUnit: function () {
			var self = this;
			var unit_data = self.$store.getters.getUnitData;
			var actualUnits = self.$store.getters.getCharaIdentity;
			var list = new Array();
			_.forEach(unit_data, function (value) {
				_.forEach(actualUnits, function (o) {
					if (o.unit_id == _.toInteger(value.unit_id) && value.cutin_1 != "0") {
						var profile = _.find(self.unitProfile, ["unit_id", value.unit_id]);
						o["rarity"] = value.rarity;
						o["kana"] = value.unit_name;
						o["profile"] = profile;
						list.push(o);
					}
				});
			});
			list = _.groupBy(list, function (e) { return e.profile.guild });
			return list;
		},
		gachaPoolList: function () {
			var self = this;
			var unit_data = self.$store.getters.getUnitData;
			var actualUnits = self.$store.getters.getCharaIdentity;
			var filter = this.filter;
			var list = new Array();
			var pool = {
				"常駐池": [],
				"季節限定": [],
				"期間限定": [],
				"公主祭典": [],
				"一星": [],
				"二星": [],
				"活動一星": [],
				"額外兌換": [],
				"尚未更新": [],
			}
			var unit_list = [];
			_.forEach(unit_data, function (value) {

				_.forEach(actualUnits, function (o) {
					if (o.unit_id == _.toInteger(value.unit_id) && value.cutin_1 != "0") {
						unit_list.push(o.unit_id);
					}
				});
			});
			var getAllPool = _.reduce(this.gachaPool, function (result, value, key) {
				return _.concat(result, value);
			})

			function arr_diff(a1, a2) {
				var a = [],
					diff = [];

				for (var i = 0; i < a1.length; i++) {
					a[a1[i]] = true;
				}

				for (var i = 0; i < a2.length; i++) {
					if (a[a2[i]]) {
						delete a[a2[i]];
					} else {
						a[a2[i]] = true;
					}
				}

				for (var k in a) {
					diff.push(k);
				}

				return diff;
			}
			this.gachaPool.undefined = arr_diff(getAllPool, unit_list);

			_.forEach(this.gachaPool, function (item, key) {
				_.forEach(item, function (value) {
					var obj = {};
					var profile = _.find(unit_data, ["unit_id", value]);
					try {
						obj["en_name"] = profile.en_name;
						obj["cn_name"] = profile.cn_name;
						obj["jp_name"] = profile.jp_name;
						obj["nickname"] = profile.nickname;
						obj.kana = profile.unit_name;
						obj.unit_id = value;
						switch (key) {
							case "always":
								pool["常駐池"].push(obj);
								break;
							case "season":
								pool["季節限定"].push(obj);
								break;
							case "limited":
								pool["期間限定"].push(obj);
								break;
							case "fes":
								pool["公主祭典"].push(obj);
								break;
							case "star1":
								pool["一星"].push(obj);
								break;
							case "star2":
								pool["二星"].push(obj);
								break;
							case "eventStar1":
								pool["活動一星"].push(obj);
								break;
							case "extra":
								pool["額外兌換"].push(obj);
								break;
							case "undefined":
								pool["尚未更新"].push(obj);
								break;
							default:
								//pool["尚未更新"].push(obj);
								break;
						}
					} catch (e) { }


				});
			});
			return pool;
		}
	},
	methods: {
		changeFilter: function (item) {
			if (this.filter != item) {
				this.filter = item;
				this.arrange = "desc";
			} else {
				if (this.arrange == "desc") {
					this.arrange = "asc";
				} else {
					this.arrange = "desc";
				}
			}
		},
		getUnitName: function (unit) {			
			switch (this.locale) {
				case "tw":
					return unit.kana
				case "cn":
					return unit.cn_unit_name
				case "jp":
					return unit.jp_unit_name
				case "en":
					return unit.en_unit_name
				default:
					return unit.kana
			}
		},
		changeShowType: function (item) {
			if (this.showType != null || this.showType != "") {
				this.showType = item;
			} else {
				this.showType = "";
			}
		},
		debounceInput: _.debounce(function (e) {
			if (e.target.value != "") {
				this.showType = '1';
			} else {
				this.showType = "";
			}
			this.filterName = e.target.value;

		}, 1000),
		gachaPoolTitle: function (poolName) {
			switch (poolName) {
				case "常駐池":
					return this.$t('PermanentGacha')
				case "季節限定":
					return this.$t('SeasonLimitedGacha')
				case "期間限定":
					return this.$t('limited')
				case "公主祭典":
					return this.$t('GalaGacha')
				case "一星":
					return this.$t('one_star')
				case "二星":
					return this.$t('two_star')
				case "活動一星":
					return this.$t('event_one_star')
				case "額外兌換":
					return this.$t('ExtraUnit')
				case "尚未更新":
					return this.$t('NotUpdated')
				default:
					break
			}
		},
	},
	created: function () {
		var self = this;
		var unitProfile = JSON.parse(self.atou(unit_profile));
		_.find(unitProfile, ["unit_id", "101401"]).age = "15";
		_.find(unitProfile, ["unit_id", "112201"]).age = "15";
		_.find(unitProfile, ["unit_id", "110001"]).age = "17";
		_.find(unitProfile, ["unit_id", "101601"]).age = "17";
		_.find(unitProfile, ["unit_id", "101701"]).age = "17";
		_.find(unitProfile, ["unit_id", "110501"]).age = "17";
		_.find(unitProfile, ["unit_id", "105201"]).age = "17";
		_.find(unitProfile, ["unit_id", "115801"]).age = "17";
		_.find(unitProfile, ["unit_id", "105301"]).age = "17";
		_.find(unitProfile, ["unit_id", "114201"]).age = "17";
		_.find(unitProfile, ["unit_id", "107901"]).age = "19";
		_.find(unitProfile, ["unit_id", "104601"]).age = "19";
		this.unitProfile = unitProfile;
	},
	mounted: function () {
		var self = this;
		var units = self.$store.getters.getUnitData;
		var actualUnits = this.$store.getters.getCharaIdentity;
		var unitTalent = JSON.parse(self.atou(unit_talent));
		function processRarity(rarity) {
			var newList = [];
			const filteredList = units.filter(unit => Number(unit.rarity) === rarity);
			filteredList.forEach(unit => {
				const matchedActualUnit = actualUnits.find(actualUnit => actualUnit.unit_id == _.toInteger(unit.unit_id));
				const talentUnit = unitTalent.find(obj => obj.unit_id == _.toInteger(unit.unit_id));
				if (matchedActualUnit) {
					if (talentUnit) {
						matchedActualUnit["talent_id"] = talentUnit.talent_id
					}
					matchedActualUnit["cn_unit_name"] = unit.cn_unit_name;
					matchedActualUnit["en_unit_name"] = unit.en_unit_name;
					matchedActualUnit["jp_unit_name"] = unit.jp_unit_name;
					matchedActualUnit["rarity"] = unit.rarity;
					matchedActualUnit["kana"] = unit.unit_name;
					newList.push(matchedActualUnit)
				}


			});
			return newList.filter(unit => unit);
		}

		self.star3 = processRarity(3);
		self.star2 = processRarity(2);
		self.star1 = processRarity(1);
	}
}
</script>
<style scoped></style>